import React from 'react'
import { StatusBadge } from 'components/atoms'
import { utilService } from '../../../../core/services'
import { ContentBody, ContentHeader, RowSection, SectionContent } from '../layout'
import DataRow from './DataRow'
import { emptyValue, getPaymentStatusBadgeType } from './helpers'
import { IOtaReservation } from 'static/interfaces'
import I18n from 'core/i18n'

interface IProps {
  otaReservation: IOtaReservation
}

const SalesPaymentSectionContent = ({ otaReservation }: IProps) => {
  return (
    <SectionContent>
      <ContentHeader>支払い情報</ContentHeader>
      <ContentBody className="single-column">
        <RowSection>
          <DataRow
            label="Payment Status"
            content={
              <StatusBadge
                type={getPaymentStatusBadgeType(otaReservation.payment_status_id)}
                label={otaReservation.payment_status_id}
              />
            }
          />
          <DataRow label="Currency" content={emptyValue(otaReservation.currency)} />
          <DataRow
            label={I18n.t('generic.payment_amount')}
            content={utilService.formatPriceOnlyYen(otaReservation.total_price)}
          />
          <DataRow
            label="Payment Process Cost"
            content={utilService.formatPriceOnlyYen(otaReservation.payment_process_cost || 0)}
          />
          <DataRow
            label="System Cost"
            content={utilService.formatPriceOnlyYen(otaReservation.system_cost || 0)}
          />
          {otaReservation.refund_amount && (
            <DataRow
              label="Refund Amount"
              content={utilService.formatPriceOnlyYen(otaReservation.refund_amount)}
            />
          )}
        </RowSection>
      </ContentBody>
    </SectionContent>
  )
}

export default SalesPaymentSectionContent
